@use "foundation/_colors.scss";
@use "foundation/_typography_base.scss";

.ingredient-combo-container {
  font-family: typography_base.$code;

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    font-size: 16px;
    font-weight: 700;

    white-space: nowrap;
    overflow: hidden;

    span.header-name {
      line-height: 24px;
      margin-right: 1em;
    }

    span.service-list {
      display: flex;
      flex-direction: row;
      align-items: center;

      a {
        cursor: pointer;
        margin-right: 8px;
        line-height: 0;

        &:last-of-type {
          margin-right: 0;
        }

        img {
          width: 22px;
          height: 22px;
          filter: invert(1);
        }
      }
    }
  }

  ul.ingredient-combobox {
    $text-size: 12px;
    $item-height: 28px;

    background-color: colors.$neutrals-light-grey;
    height: 44px;
    border-radius: 8px;
    padding: 8px 16px 8px 20px;
    font-size: $text-size;
    cursor: pointer;

    li {
      height: $item-height;
      line-height: $item-height;

      &.placeholder {
        display: flex;
        align-items: center;
        justify-content: space-between;

        span:last-of-type {
          display: flex;
        }

        svg {
          width: 10px;
        }
      }

      &.service {
        font-weight: 700;
        margin-top: 16px;
      }

      &.service-options {
        height: 100%;
        margin-left: 8px;

        li {
          position: relative; /* Safari fix for hover pseudo element */
          margin-bottom: 8px;
        }
      }

      &.help-text {
        height: auto;
        margin-top: 16px;
        padding-top: 12px;
        border-top: 1px solid colors.$neutrals-grey;

        ul {
          li {
            height: auto;
            color: colors.$neutrals-dark-grey;
            font-size: 11px;
            font-weight: 400;
            line-height: 16px;
            margin-bottom: 4px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    &.opened {
      cursor: default;
      height: 100%;

      li.placeholder {
        cursor: pointer;

        svg {
          width: 14px;
        }
      }

      li.service-options ul > li {
        input[type="text"] {
          font-family: typography_base.$code;
          font-size: $text-size;
          font-weight: 500;
          padding: 0;
          padding-right: 2em;
          border-radius: 0;
          line-height: $item-height;

          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          background-color: transparent;
          border: none;

          &::selection {
            background: #BADEFE;
          }

          &::-moz-selection {
            background: #BADEFE;
          }
        }
      }
    }
  }
}
